import {
  Card,
  CardBody,
  Input,
  TableRow,
  Table,
  TableCell,
  TableContainer,
  TableHeader,
  Button,
} from "@windmill/react-ui";
import ExportDataXlsx from "components/common/ExportDataXlsx";
import HourRentalPeriodicHikeDayTable from "components/hourRentalPeriodicHikeDay/HourRentalPeriodicHikeDayTable";
import DataWrapper from "./DataWrapper";
import NotFound from "components/table/NotFound";
import PageTitle from "components/Typography/PageTitle";
import { SidebarContext } from "context/SidebarContext";
import useAsync from "hooks/useAsync";
import Somethingwentwrong from "pages/Somethingwentwrong";
import useFilter from "hooks/useFilter";
import { useState, useContext, useEffect } from "react";
import HourRentalPeriodicHikeDayServices from "services/HourRentalPeriodicHikeDayServices";
import { FiPlus } from "react-icons/fi";
import HourRentalPeriodicHikeDayDrawer from "components/drawer/HourRentalPeriodicHikeDayDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import useToggleDrawer from "hooks/useToggleDrawer";
import sidebar from "routes/sidebar";

const HourRentalPeriodicHikeDay = () => {
  const adminInfo = localStorage.getItem("adminInfo")
    ? JSON.parse(localStorage.getItem("adminInfo"))
    : null;
  const { toggleDrawer } = useContext(SidebarContext);
  const { title, serviceId } = useToggleDrawer();
  const [status, setStatus] = useState("");
  const { data, loading, error } = useAsync(
    HourRentalPeriodicHikeDayServices.getAllHrRentalPeriodicHikeDay,
  );

  const isAdmin = adminInfo?.id === 1;

  const hideView = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "periodic hike day" && perm.view === 1,
  );

  const hideDelete = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "periodic hike day" && perm.delete === 1,
  );

  const hideEdit = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "periodic hike day" && perm.edit === 1,
  );

  const hideAdd = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "periodic hike day" && perm.add === 1,
  );

  const hideExport = adminInfo?.permission?.some(
    (perm) => perm.id_tab === "periodic hike day" && perm.export === 1,
  );
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const {
    hourRentalPeriodicHikeDayRef,
    dataTable,
    serviceData,
    handleSubmitHourRentalPeriodicHikeDay,
    currentPage,
  } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);

  useEffect(() => {
    if (serviceData.length !== 0) {
      setItemsPerPage(serviceData.length);
    }
  }, [serviceData]);

  useEffect(() => {
    if (data?.status) {
      setStatus(data.status);
    } else {
      setStatus(false);
    }
  }, [data?.status]);

  const isDataArray = Array.isArray(data?.data); // Check if data is an array
  const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array
  // console.log("data from safedata", safeData);
  const exportDataXlsx = safeData.map((item, index) => {
    const vehicleTypes = item.vehicle_type_id || [];
    const vehicleHikes = Object.fromEntries(
      vehicleTypes.map((id) => [
        item.vehicle_type_names?.[id] || `Vehicle_${id}`,
        `${item.hike?.[id] || 0}%`,
      ]),
    );

    return {
      SINo: index + 1,
      City: item.city_names,
      StartDate: new Date(item.start_date).toLocaleDateString("en-GB"),
      EndDate: new Date(item.end_date).toLocaleDateString("en-GB"),
      ...vehicleHikes,
    };
  });

  return (
    <>
      {hideView && (
        <>
          <DeleteModal id={serviceId} title={title} />

          <MainDrawer>
            <HourRentalPeriodicHikeDayDrawer id={serviceId} />
          </MainDrawer>

          <PageTitle sidebar={sidebar().sidebar} />

          <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
            <CardBody>
              <div className="flex gap-6 items-center">
                <div className="flex-1">
                  <Input
                    ref={hourRentalPeriodicHikeDayRef}
                    className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                    type="search"
                    name="search"
                    autoComplete="off"
                    placeholder="Quick Search"
                    onChange={handleSubmitHourRentalPeriodicHikeDay}
                  />
                </div>

                {hideAdd && (
                  <Button
                    onClick={toggleDrawer}
                    className="w-56 rounded-md h-10"
                  >
                    <span className="mr-3">
                      <FiPlus />
                    </span>
                    Add Periodic Day Rate
                  </Button>
                )}

                {hideExport && (
                  <ExportDataXlsx
                    exportDataXlsx={exportDataXlsx}
                    fileNames="Hour Rental Periodic Hike"
                  />
                )}
              </div>
            </CardBody>
          </Card>

          <DataWrapper loading={loading} error={error} status={status}>
            {serviceData?.length !== 0 ? (
              <TableContainer className="mb-4">
                <div
                  className="overflow-y-scroll"
                  style={{ maxHeight: "65vh", scrollbarWidth: "thin" }}
                >
                  <Table>
                    <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                      <TableRow>
                        <TableCell>Sl.No.</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>Start Date</TableCell>
                        <TableCell>End Date</TableCell>
                        <TableCell>Vehicle Type</TableCell>
                        <TableCell>Hike (%)</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHeader>
                    <HourRentalPeriodicHikeDayTable
                      hourRentalPeriodicHikeDay={dataTable}
                      perpage={itemsPerPage}
                      currentPage={currentPage}
                      hideDelete={hideDelete}
                      hideEdit={hideEdit}
                    />
                  </Table>
                </div>
              </TableContainer>
            ) : (
              <>
                {data.status !== true ? (
                  <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                ) : (
                  <NotFound title="There is no periodic Hike." />
                )}
              </>
            )}
          </DataWrapper>
        </>
      )}
    </>
  );
};

export default HourRentalPeriodicHikeDay;
